import {ProductsListContext} from "../../../Contexts/ProductsListContext";
import React, {useContext, useEffect, useState} from "react";
import {CartContext} from "../../../Contexts/CartContext";
import {useProductData} from "../ProductData";
import {useTranslation} from "react-i18next";
import {SimpleModal, useSimpleModalState} from "../../../Components/SimpleModal";
import {IconsDesignation} from "../IconsDesignation";
import {Link} from "react-router-dom";
import {QuantityDisposition} from "../Components/QuantityDisposition";
import {useAddProductToCart} from "../../Cart/AddProduct/api";
import {QuantityFields} from "../../Cart/AddProduct/components/QuantityFields";
import {MinimumOrderQuantity} from "../MinimumOrderQuantity/MinimumOrderQuantity";
import {QuantityFieldsData} from "../../Cart/AddProduct/types";
import {ProductInterface} from "../DataInterface";
import {CartType} from "../../../Types/CartType";
import {ChannelContext} from "../../../Contexts/ChannelContext";
import {UserContext} from "../../../Contexts/UserContext";
import {Gallery} from "../../../Components/Gallery";

function OldPlatformStyle(): React.ReactElement {
    const productsListContext = useContext(ProductsListContext);
    const [data, setData] = useState(productsListContext?.products);
    const [gallery, setGallery] = useState(null);

    useEffect(() => {
        setData(productsListContext?.products);
    }, [productsListContext?.products]);

    return(
        <div className="old-platform">
            <Gallery images={gallery} close={setGallery} />
            {productsListContext?.products.map((product, key) => {
                return <Item data={product} key={product.id} setGallery={setGallery} />
            })}
        </div>
    );
}

function Item({data, setGallery}: {data: ProductInterface, setGallery: any}): React.ReactElement {
    const cartContext               = useContext(CartContext);
    const productsListContext       = useContext(ProductsListContext);
    const channelContext            = useContext(ChannelContext);
    const userContext               = useContext(UserContext);
    const product                   = useProductData(data);
    const {t}                       = useTranslation();
    const {addProductToCart}         = useAddProductToCart();
    const [response, setResponse]   = useState<CartType|null>(null);
    const {visibility, toggleVisibleModal} = useSimpleModalState();

    // useEffect(() => {
    //     if (response !== null){
    //         cartContext?.setCart(response);
    //     }
    // }, [response]);

    if (product === null){
        return <></>;
    }

    const iconsDesignation = new IconsDesignation(product, t);
    const quantityFieldsData = {
        product,
        products: productsListContext?.products!,
        setProducts: productsListContext?.setProducts!,
        addProductToCart
    } as unknown as QuantityFieldsData;

    function displayPrice(): React.ReactElement {
        if (!userContext?.user && channelContext?.displayPriceNotLogged === true){
            return <div><span>{t('products-list.disable-price-not-logged')}</span></div>
        }

        if (userContext?.user && channelContext?.displayPriceLogged === true){
            return <div><span>{t('products-list.disable-price-logged')}</span></div>
        }

        return (
            <>
                <div className="netto" >
                    <span>{t('products-list.price-netto-after-discount')}:</span> <span>{product?.priceNetto !== 0 ? product?.priceNetto.toFixed(2) : product?.priceBefore.toFixed(2)} </span>
                </div>
                <div className="brutto" >
                    <span>{t('products-list.price-brutto-after-discount')}:</span> <span>{product?.priceBrutto !== 0 ? product?.priceBrutto.toFixed(2) : product?.priceBeforeBrutto.toFixed(2)} </span>
                </div>
            </>
        );
    }

    function displayQuantity(): React.ReactElement {
        if (!userContext?.user && channelContext?.displayQuantityNotLogged === true){
            return <div><span>{t('products-list.disable-quantity-not-logged')}</span></div>
        }

        if (userContext?.user && channelContext?.displayQuantityLogged === true){
            return <div><span>{t('products-list.disable-quantity-logged')}</span></div>
        }

        return (
            <div className="quantity" >
                <span>{t('products-list.avail')}:</span>
                {/*@ts-ignore */}
                <span><QuantityDisposition quantity={product.quantity} unit={product.unit} /></span>
            </div>
        );
    }

    return (
        <section className="product" >
            {iconsDesignation.getIcons()}

            <div className={'left'} >
                <div className="thumb" style={{backgroundImage: 'url('+product.thumb+')'}} onClick={() => setGallery(product.images)} >
                    <i className="fas fa-search-plus more" />
                </div>
            </div>

            <div className="desc" >
                <div className="attributes" >

                    {displayPrice()}

                    <div className="index" >
                        <span>{t('products-list.index-et')}:</span>
                        <span>{product.indexHurt}</span>
                    </div>
                    <div className="ean" >
                        <span>{t('products-list.ean')}:</span>
                        <span>{product.ean !== null ? product.ean : '-'}</span>
                    </div>

                    {displayQuantity()}

                    <div className="package" >
                        <span>{t('products-list.in-package')}:</span>
                        <span>{product.quantityPackage}</span>
                    </div>
                    <MinimumOrderQuantity product={product} />

                    {userContext?.user && channelContext?.displayPriceLogged === true ? null :
                        <div className="add-to-cart" >
                            <QuantityFields data={quantityFieldsData} label={true} revers={true} />
                        </div>
                    }
                </div>
            </div>

            <Link to={'/product/'+product.slug} >
                <h2>{product.name}</h2>
            </Link>
        </section>
    );
}

export {OldPlatformStyle};
